export const STORE_LOCATOR_SEARCH_PARAMS = {
    PARTNER_STORES: "partnerStores",
} as const;

export const PARTNER_STORES_PARAM_VALUES = {
    OFF: "off",
} as const;
